import React from 'react';
import { Badge, Box, HStack, Text, useColorModeValue } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useUser } from '../../contexts/UserContext';

const TrialStatusBanner = () => {
  const { t } = useTranslation();
  const { trialAccess } = useUser();
  const bg = useColorModeValue('blue.50', 'blue.900');
  const borderColor = useColorModeValue('blue.100', 'blue.700');
  const badgeBg = useColorModeValue('blue.100', 'blue.800');
  const textColor = useColorModeValue('blue.800', 'blue.100');
  const mutedColor = useColorModeValue('blue.700', 'blue.200');

  if (!trialAccess?.isTrial || trialAccess?.accessBlocked || trialAccess?.daysRemaining == null) {
    return null;
  }

  const message =
    trialAccess.daysRemaining === 1
      ? t('trial_access.banner.one_day')
      : t('trial_access.banner.multiple_days', { count: trialAccess.daysRemaining });

  return (
    <Box px={{ base: 4, md: 6 }} py={3} bg={bg} borderBottomWidth="1px" borderColor={borderColor}>
      <HStack spacing={3} flexWrap="wrap">
        <Badge bg={badgeBg} color={textColor} px={2.5} py={1} borderRadius="full">
          {t('trial_access.banner.badge')}
        </Badge>
        <Text color={textColor} fontSize="sm" fontWeight="medium">
          {message}
        </Text>
        <Text color={mutedColor} fontSize="sm">
          {t('trial_access.banner.secondary')}
        </Text>
      </HStack>
    </Box>
  );
};

export default TrialStatusBanner;
